import React, { useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { withPackage } from "../../../components/withPackage/withPackage"
import { iArtist } from "../../../definitions/Artists"
import { post } from "../../../store/data/actions"
import ArtistHeader from "../Header"
import ArtistOverview from "../inspector/Overview"
import ArtistUploads from "../inspector/Uploads"

const CreateArtist = () => {
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iArtist) => {
    setLoading(true)
    post<iArtist>({ link: "/v1/create-artist", data }).then((artist) => {
      setLoading(false)
      history.push("/artists/" + artist.url)
      store.addNotification({
        title: "Success!",
        message: "Artist successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <ArtistHeader
        type="create"
        submitDeleteText="Delete"
        title="Create Artist"
        submitText="Create"
        handleSubmit={async () => {
          const result = await methods.trigger()
          console.log(result)

          if (result) {
            methods.handleSubmit((data) => {
              onSubmit(data as iArtist)
            })()
          }
        }}
        isLoading={isLoading}
      />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iArtist)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <ArtistOverview />
          </Route>
          <Route exact path={match.path + "/uploads"}>
            <ArtistUploads />
          </Route>
          <button type="submit" className="btn-blue d-none">
            Save Changes
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default withPackage(CreateArtist, "Artists")
